<div class="informations-and-contact-container">
  <h1>Informations and Contact</h1>
  <div tds-tile variant="auto">
      <h4>Access Request</h4>
      <div>If you want access to the application please fill the form
          <a href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=sJGeMh_i-0igcUVnF-zCjpEdBlIh0K9Ftfpay4TFb4lUOE85OU8zSEdVR1JFTVRLMTI2MVZNU0hEOC4u" target="_blank" rel="noopener">here</a> .</div>
  </div>
  <div class="two-rows-container">
    <div class="left-column">

      <div tds-tile variant="auto">
        <h4>Q&A</h4>
        <div class="questions-container">
          <div>
            <span style="font-weight: bold">Q1. What sources are available?</span>
            <div>The Price Scenarios Finder (PSF) includes a range of both internal and external data sources.
              External sources include <strong>Afry</strong> and <strong>Aurora</strong>, two well-established consultancy firms widely recognized in the power sector.
              Internal sources are <strong>PMF</strong> and <strong>3MV</strong>. PMF is part of the GRP/FPI team and primarily provides forecasts used to evaluate new investments by TotalEnergies in power generation-related activities. 3MV, on the other hand, belongs to GRP/TRD and focuses on forecasts used for energy trading operations.</div>
          </div>
          <div>
            <span style="font-weight: bold">Q2. What if I need a forecast from a different data provider?</span>
            <div>The data shown in the PSF is retrieved via APIs from Afry and Aurora. Unfortunately, one-off purchases or data from other providers cannot be displayed in the Price Scenarios Finder.</div>
          </div>
          <div>
            <span style="font-weight: bold">Q3. What should I do if I need to share this data with an external party?</span>
            <div>Please reach out to the PMF team. You’ll need to complete a contract amendment and pay a fee in order to obtain permission to share the data externally. </div>
          </div>
        </div>
      </div>

      <div class="two-rows-container">
        <div tds-tile variant="auto">
          <h4>Publication Planning</h4>
          <div>Afry, Aurora, and 3MV scenarios are updated quarterly. PMF scenarios are refreshed twice a year, following the LTP and BU cycles.</div>
        </div>

        <div tds-tile variant="auto">
          <h4>Main Hypothesis</h4>
          <div>Report highlighting the main hypothesis of the external forecaster can be found
            <a href="https://totalworkplace.sharepoint.com/:u:/r/sites/Intelligence/SitePages/Long-term-Power-Price-Scenarios.aspx?csf=1&web=1&e=NR4mjZ" target="_blank" rel="noopener">here</a> . Access can be demanded on the page.</div>
            <br>
            <div>
                For questions pertaining to data quality, you may contact :
                <div class="contact-name">Vladimir Blokhin</div>
                <div class="email"><a href="mailto:vladimir.blokhin@external.totalenergies.com">vladimir.blokhin&#64;external.totalenergies.com</a></div>
            </div>
        </div>

        <div tds-tile variant="auto">
          <h4>Methodology</h4>
          <div>Find below a PDF that explains how merchant scenarios are built.</div>
          <div class="tile-footer">
            <button tds-button variant="secondary" size="md" disabled><tds-icon
              name="open_in_new"
              size="sm"
            />(PDF not available yet) </button>
          </div>
        </div>
      </div>
    </div>

    <div class="right-column">
      <div tds-tile variant="auto">
        <h4>Contact</h4>
        <div>If you have any questions regarding merchant forecasts, you can reach out directly to the analyst responsible for each country. Simply click the <strong>Contact</strong> button located in the <strong>Actions</strong> column on the right-hand side of the table displaying your selected scenarios.</div>
        <br>
        <div>For any inquiries related to the Price Scenarios Finder (PSF), please contact the product owner of this digital solution:</div>
        <div class="contact-container">
          <div class="contact-name">Ayman Alkhirbash</div>
          <div class="email"><a href="mailto:ayman.alkhirbash&#64;totalenergies.com">ayman.alkhirbash&#64;totalenergies.com</a></div>
        </div>
      </div>
    </div>
  </div>
</div>
